module.exports = new __parcel__URL__("level_icon.dfd04cc8.png").toString();